// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"77c8b71e","473":"d67c1f28"}[chunkId] + ".chunk.css";
};